var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59,32h-6c-0.553,0-1,0.447-1,1v1h-8v-7c0-0.553-0.447-1-1-1h-4v-3h6c0.553,0,1-0.447,1-1V6c0-0.553-0.447-1-1-1h-1V3 c0-0.553-0.447-1-1-1H19c-0.553,0-1,0.447-1,1v2h-1c-0.553,0-1,0.447-1,1v16c0,0.553,0.447,1,1,1h6v3h-4c-0.553,0-1,0.447-1,1v7H8 v-1c0-0.553-0.447-1-1-1H1c-0.553,0-1,0.447-1,1v6v6v6v6c0,0.553,0.447,1,1,1h6c0.553,0,1-0.447,1-1v-1h44v1c0,0.553,0.447,1,1,1h6 c0.553,0,1-0.447,1-1v-6v-6v-6v-6C60,32.447,59.553,32,59,32z M58,44h-4v-4h4V44z M54,46h4v4h-4V46z M54,34h4v4h-4v-3V34z M34,21V7 h2v14H34z M30,21V7h2v14H30z M26,21V7h2v14H26z M22,21V7h2v14H22z M38,7h2v14h-2V7z M44,21h-2V7h1h1V21z M20,4h22v1H20V4z M18,7h1h1 v14h-2V7z M25,23h12v3H25V23z M6,44H2v-4h4V44z M2,46h4v4H2V46z M2,34h4v1v3H2V34z M6,56H2v-4h4v3V56z M8,54v-3v-6v-6v-3h11 c0.553,0,1-0.447,1-1v-7h4h14h4v7c0,0.553,0.447,1,1,1h9v3v6v6v3H8z M58,56h-4v-1v-3h4V56z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagram);
export default __webpack_public_path__ + "static/media/diagram.29b6f47a2d605323ef11020db8ac7341.svg";
export { ForwardRef as ReactComponent };